// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b524f5f8","453":"7488833a","667":"b3b9081b","690":"abc38bdc","721":"dd1a2180","884":"c9ec96b9"}[chunkId] + ".chunk.js";
};